"use client";

import { useEffect } from "react";

import { useStore } from "~/hooks/store";
import { authClient } from "./better-auth-client";

export const AuthComponent = () => {
  const setLoggedUser = useStore((s) => s.setLoggedUser);
  useEffect(() => {
    authClient
      .getSession()
      .then((s) => {
        if (s.data?.user) {
          setLoggedUser({
            displayName: s.data.user.name,
            email: s.data.user.email,
            photoURL: s.data.user.image || "",
            uid: s.data.user.id,
            isAnonymous: s.data.user.isAnonymous ?? undefined,
          });
        }
      })
      .catch((e) => {
        // Best-effort session hydration: a failed getSession fetch (e.g.
        // "Failed to fetch" from a network blip or blocking extension) is not
        // actionable — the no-user path renders fine. Log below Sentry's
        // captureConsoleIntegration error threshold to avoid noise (WEBAPP-103).
        console.warn("getSession failed", e);
      });
  }, []);

  return null;
};
